import React, { useState } from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';
import * as middlewareSearch from 'app/blocks/middleware/search';
import MiniSearch from 'app/blocks/mini-search/MiniSearch';
import AdvanceSearchButtons from 'app/pages/search/advance-search-buttons/AdvanceSearchButtons';
import { goBack } from 'app/route/history';
import { Input2 } from 'app/ui/form/inputs';
import Select from 'app/ui/form/Select';

function ContentSearch(props) {
    const {
        articleForm: {
            fields: { doi, editorialRefCode, journalTitle },
        },
        codes,
        disabledSearchBtn,
        onSearch,
        onValueChange,
    } = props;
    const componentCodes = codes.SEARCH_CODES.SEARCH.searchBy;
    const searchCriteria = [componentCodes.criteria.doi, componentCodes.criteria.ref];

    const [journalApiData, setJournalApiData] = useState(null);

    const [searchBy, setSearchBy] = useState(searchCriteria[journalTitle ? 1 : 0]);

    const onChangeSearch = event => {
        setSearchBy(event.target.value);
        onValueChange('doi', '');
        onValueChange('journalTitle', '');
        onValueChange('editorialRefCode', '');
    };

    const handleSearch = async query => {
        onValueChange('journalTitle', query);
        let data = [];
        if ((query || '').trim()) {
            data = (await middlewareSearch.journalOnlySearch({ title: query }, { offset: 0, size: 5 })).items;
            setJournalApiData(data);
        } else {
            setJournalApiData(data);
            onValueChange('journalTitle', '');
        }
    };

    const handleSearchListClick = (id, name) => {
        onValueChange('journalTitle', name);
    };

    return (
        <>
            <div className="MissingArticleDetails-FormContent" data-seleniumid="article-info-search">
                <h3 className="subtitle m-btm_normal">{componentCodes.title}</h3>
                <section className="SearchContainer">
                    <div className="SearchRow">
                        <label htmlFor="searchCriteria">{componentCodes.search_by}</label>
                        <Select
                            data-seleniumid="article-search-criteria"
                            id="searchCriteria"
                            onChange={onChangeSearch}
                            selected={searchBy}
                            value={searchBy}
                        >
                            {searchCriteria.map(criteria => (
                                <option key={criteria} data-seleniumid={criteria} value={criteria}>
                                    {criteria}
                                </option>
                            ))}
                        </Select>
                    </div>
                    {searchBy === searchCriteria[0] && (
                        <div className="SearchRow">
                            <label htmlFor="search-advanced-search-doi-input">{componentCodes.criteria.doi}</label>
                            <Input2
                                data-seleniumid="search-advanced-search-doi-input"
                                id="search-advanced-search-doi-input"
                                onChange={value => onValueChange('doi', value)}
                                value={doi}
                            />
                        </div>
                    )}

                    {searchBy === searchCriteria[1] && (
                        <>
                            <div className="SearchRow">
                                <label htmlFor="search-advanced-search-editorialRefCode-input">
                                    {componentCodes.criteria.ref}
                                </label>
                                <Input2
                                    data-seleniumid="search-advanced-search-editorialRefCode-input"
                                    id="search-advanced-search-editorialRefCode-input"
                                    onChange={value => {
                                        onValueChange('editorialRefCode', value);
                                    }}
                                    value={editorialRefCode}
                                />
                            </div>
                            <div className="SearchRow">
                                <label htmlFor="journalSearch">{componentCodes.criteria.journal}</label>
                                <MiniSearch
                                    defaultValue={journalTitle}
                                    onInput={handleSearch}
                                    searchResults={journalApiData}
                                    seleniumId="journalSearch-combobox-input"
                                >
                                    <ul className="MiniSearchContent">
                                        {journalApiData &&
                                            journalApiData.map(journal => (
                                                <li key={journal.id}>
                                                    <button
                                                        onClick={() =>
                                                            handleSearchListClick(journal.id, journal.doc.title)
                                                        }
                                                        type="button"
                                                    >
                                                        {journal.doc.title}
                                                    </button>
                                                </li>
                                            ))}
                                    </ul>
                                </MiniSearch>
                            </div>
                        </>
                    )}
                </section>
            </div>
            <AdvanceSearchButtons
                disableOnNext={disabledSearchBtn}
                nextButtonText={componentCodes.search_btn}
                onNext={onSearch}
                onPrevious={goBack}
                previousBtnText={componentCodes.back_btn}
            />
        </>
    );
}

export default withCodes(ContentSearch, ID.SEARCH_CODES);
